import React from 'react';
import { cn, PLAYERS } from '../../lib/utils';
import { PlayerId } from '../../lib/game-logic';
interface BoardSquareProps {
  product: number;
  owner?: PlayerId;
  isHighlight?: boolean;
  isLastMove?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}
export function BoardSquare({
  product,
  owner,
  isHighlight,
  isLastMove,
  onClick,
  disabled
}: BoardSquareProps) {
  return <button onClick={onClick} disabled={disabled || !!owner} className={cn('relative w-full aspect-square flex items-center justify-center rounded-lg text-sm font-bold transition-all duration-200', 'bg-slate-100 text-slate-400 border-2 border-transparent', !owner && !disabled && 'hover:bg-slate-200 hover:scale-105 active:scale-95 cursor-pointer', isHighlight && !owner && 'bg-blue-50 border-blue-300 text-blue-600 shadow-[0_0_15px_rgba(59,130,246,0.3)] z-10 scale-105', owner && 'border-transparent shadow-sm', owner === 1 && 'bg-violet-100', owner === 2 && 'bg-teal-100', disabled && !owner && 'opacity-50 cursor-not-allowed')} data-id="element-78">
      {/* Product Number (faded if owned) */}
      <span className={cn('z-0 transition-opacity', owner ? 'opacity-30 scale-75' : 'opacity-100')} data-id="element-79">
        {product}
      </span>

      {/* Chip */}
      {owner && <div className={cn('absolute inset-1 rounded-full shadow-md flex items-center justify-center animate-in zoom-in duration-300', PLAYERS[owner].colorClass, isLastMove && 'ring-4 ring-white ring-opacity-50')} data-id="element-80">
          {/* Pattern overlay */}
          {owner === 1 && <div className="w-full h-full opacity-20 bg-[repeating-linear-gradient(45deg,transparent,transparent_5px,#000_5px,#000_10px)] rounded-full" data-id="element-81" />}
          {owner === 2 && <div className="w-full h-full opacity-20 bg-[radial-gradient(circle,#000_2px,transparent_2.5px)] bg-[length:8px_8px] rounded-full" data-id="element-82" />}
        </div>}
    </button>;
}